<script>
  /**
   * Reusable Card Component with Glassmorphism
   * @prop {string} variant - 'default' | 'elevated' | 'outlined' | 'glass' | 'solid'
   * @prop {string} padding - 'none' | 'sm' | 'md' | 'lg'
   * @prop {boolean} hover - Enable hover effects
   */
  let {
    variant = "default",
    padding = "md",
    hover = false,
    children,
  } = $props();
</script>

<div
  class="card card-{variant} card-padding-{padding}"
  class:card-hover={hover}
>
  {@render children?.()}
</div>

<style>
  .card {
    background: var(--glass-bg);
    backdrop-filter: blur(var(--blur-lg));
    -webkit-backdrop-filter: blur(var(--blur-lg));
    border-radius: var(--radius-xl);
    overflow: hidden;
    transition:
      box-shadow var(--transition-base),
      transform var(--transition-base),
      border-color var(--transition-base);
  }

  /* Variants */
  .card-default {
    border: 1px solid var(--glass-border);
    box-shadow: var(--shadow-glass);
  }

  .card-elevated {
    border: 1px solid var(--glass-border);
    box-shadow: var(--shadow-lg), var(--shadow-glow-sm);
  }

  .card-outlined {
    background: rgba(255, 255, 255, 0.6);
    border: 1px solid var(--color-gray-200);
    box-shadow: var(--shadow-sm);
  }

  .card-glass {
    background: var(--glass-bg-light);
    border: 1px solid var(--glass-border-subtle);
    box-shadow: var(--shadow-glass);
  }

  .card-solid {
    background: white;
    backdrop-filter: none;
    border: 1px solid var(--color-gray-200);
    box-shadow: var(--shadow-md);
  }

  /* Hover Effects */
  .card-hover:hover {
    box-shadow: var(--shadow-glass-hover), var(--shadow-glow-sm);
    transform: translateY(-2px);
    border-color: var(--glass-border);
  }

  .card-elevated.card-hover:hover {
    box-shadow: var(--shadow-xl), var(--shadow-glow);
    transform: translateY(-4px);
  }

  /* Padding */
  .card-padding-none {
    padding: 0;
  }

  .card-padding-sm {
    padding: var(--space-3);
  }

  .card-padding-md {
    padding: var(--space-4);
  }

  .card-padding-lg {
    padding: var(--space-6);
  }

  @media (min-width: 640px) {
    .card-padding-md {
      padding: var(--space-6);
    }

    .card-padding-lg {
      padding: var(--space-8);
    }
  }
</style>
